import React from "react";
import { Info } from "../../assets/svgs";

import styles from "./note.module.css";

export const Note = ({
	blueVariant = false,
	title = "Note:",
	paragraph,
	children
}) => {
	return (
		<div
			className={`${styles.container} d-flex p-3 ${
				blueVariant ? styles.blueVariant : ""
			}`}
		>
			<Info />

			<div className="ml-3 flex-grow-1">
				<h6 className={styles.title}>{title}</h6>

				<div className={styles.content}>{children ?? paragraph}</div>
			</div>
		</div>
	);
};
